'use client';

import { Paper, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { memo } from 'react';
import { useStyles } from './style';
import { useHoverEffect } from './utterance.util';
import UtteranceDescription from './UtteranceDescription';
import UtteranceIcon from './UtteranceIcon';

/**
 * @name Utterance
 * @param {object} props - Strapi Data
 * @returns {JSX.Element} - Renders each utterance component from utterances
 */
const Utterance = props => {
  const theme = useTheme();
  const style = useStyles(theme, props.utteranceLength);
  const {
    isHovered,
    handleMouseEnter,
    handleMouseLeave,
    handleTouchStart,
    handleBlur,
    handleFocus,
  } = useHoverEffect();

  /**
   * @function handleUtterance - Utterance onclick functionality
   */
  const handleUtterance = () => {
    props?.setSweeprParams(prev => ({ ...prev, Utterance: props?.utteranceId }));
    const widget = window.sweeprWidget;
    if (widget) {
      widget.submitUtterance(props?.utteranceId);
    }
    if (!props?.sweeprParams?.OTC) {
      props?.showLoginVerificationModal.enable();
    }
  };
  /**
   * @function handleKeyDown - Utterance onclick functionality on key press
   * @param {Function} event - Event can be something the browser does, or something a user does
   */
  const handleKeyDown = event => {
    if (event?.key === 'Enter') {
      handleUtterance();
    }
  };

  return (
    <Paper
      sx={style.tile}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      onBlur={handleBlur}
      onFocus={handleFocus}
      onClick={handleUtterance}
      onKeyDown={handleKeyDown}
      tabIndex='0'
    >
      <Stack
        direction='row'
        alignItems={'center'}
        justifyContent='space-between'
        sx={style.utteranceTiles}
      >
        <UtteranceIcon icon={props.icon} hoverIcon={props.hoverIcon} isHovered={isHovered} />
        <UtteranceDescription description={props.description} title={props.title} />
        <UtteranceIcon
          icon={props.tileIcon}
          hoverIcon={props.tileHoverIcon}
          tileIcon
          isHovered={isHovered}
        />
      </Stack>
    </Paper>
  );
};

Utterance.displayName = 'Utterance';
export default memo(Utterance);
